import React from 'react';
import * as path from 'path'

import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';// importando o BrowserRouter do pacote que acabamos de instalar
//import { registerServiceWorker } from './serviceWorker'
import Routes from './Routes'
import { Theme } from './theme/theme'
import { ThemeProvider } from 'styled-components'
import { Provider } from 'react-redux'
import store from './services/store'

import Helmet from 'react-helmet'
import {
  isAndroid
} from "react-device-detect"

//console.log(isAndroid)
if (isAndroid) {  
  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider theme={Theme}>
        <Helmet>
          <meta name="google" content="notranslate" />
          <meta http-equiv="Content-Language" content="pt-br" />
          <meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no" />
          <meta name="mobile-web-app-capable" content="yes" />
          <meta name="full-screen" content="yes" />
          <meta name="browsermode" content="application" />
          <meta name="screen-orientation" content="portrait" />
        </Helmet>
        <Routes />
        
      </ThemeProvider>
      
    </Provider>
    , 
    document.getElementById('root'));
}else{
  ReactDOM.render(
    <div>Por seu dispositivo não rodar o sistema operacional android o acesso ao aplicativo controle de ponto será restrito.</div>, 
    document.getElementById('root'));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

